import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import theme from '../../../../assets/theme';
import { IconWrapper } from '../../../_atoms/IconWrapper';
import { appSmashes, IframeAppSmash } from './AppSmashUtils';

const AppSmashRow = ({
  onIframeIntegrationSelected,
}: {
  onIframeIntegrationSelected: (iframeIntegration: IframeAppSmash) => void;
}) => {
  const { t } = useTranslation('Host');
  return (
    <div style={{ height: '75px' }}>
      <UnsplashTitleContainer>
        <span style={{ padding: '1%' }}>{t('App smashes')}</span>
      </UnsplashTitleContainer>
      <ScrollContainer>
        <ExampleImageContainer>
          {appSmashes.map((appSmash, i) => {
            return (
              <Tooltip
                key={i}
                title={appSmash.placeholder}
                placement="bottom"
                mouseEnterDelay={0.5}
              >
                <ExampleImageWrapper
                  onClick={() => {
                    onIframeIntegrationSelected(appSmash.id);
                  }}
                >
                  <IconWrapper height="40px" width="40px">
                    {appSmash.icon}
                  </IconWrapper>
                </ExampleImageWrapper>
              </Tooltip>
            );
          })}
        </ExampleImageContainer>
      </ScrollContainer>
    </div>
  );
};

export default AppSmashRow;

const ExampleImageWrapper = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 5px;
  overflow: hidden;
  cursor: pointer;

  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);

  &:hover {
    background: #d4d6db;
  }

  &:active {
    background: #c4c4c6;
  }
`;

const ExampleImageContainer = styled.div`
  width: fit-content;
  display: flex;
  gap: 10px;
`;

const UnsplashTitleContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  button {
    border: none;
    padding: 0px 10px;
    margin-bottom: 2px;
    box-shadow: none;
  }
`;

const ScrollContainer = styled.div`
  border-radius: 5px;
  overflow-x: scroll;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
`;

export const SkeletonOverviewContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: white;
  display: flex;
  border-radius: ${theme.effects.floatingCreatorElementBorderRadius};
  box-shadow: ${theme.effects.floatingCreatorElementShadow};
  overflow: hidden;

  gap: 12px;

  .ant-skeleton-input {
    width: 113px;
    height: 80px;
    border-radius: 5px;

    min-width: unset;
  }
`;
